import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Box, Grid } from '@mui/material';

interface IProficiencyDotsSkeletonProps {}

const ProficiencyDotsSkeleton = (props: IProficiencyDotsSkeletonProps) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      {[...Array(5)].map((_, i) => {
        return (
          <Grid
            key={i}
            id='proficiency-skill-dots'
            data-testid='proficiency-skill-dots'
          >
            <Skeleton
              variant='circular'
              width='1.125rem'
              height={18}
              sx={{
                bgcolor: (theme) => theme.palette.neutral?.main,
              }}
            />
          </Grid>
        );
      })}
    </Box>
  );
};
export default ProficiencyDotsSkeleton;
